import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { resolveDefaultAppPath } from '@auth/data-access';
import { LoginPage } from '@auth/feature';

export const Route = createFileRoute('/_auth/login')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: search.redirect || resolveDefaultAppPath(context.auth.user),
      });
    }
  },
  component: LoginPage,
});
